/**
 * Module « paiements » — PAY-01 à PAY-04 (ARCHITECTURE §8, §9.2).
 *
 * Trois écrans :
 *   - `/admin/paiements`                      liste des impayés (PAY-04), écran d’entrée ;
 *   - `/admin/paiements/souscription/:id`     fiche de paiement d’une souscription (PAY-01…03) ;
 *   - `/admin/paiements/vente/:id`            fiche de paiement d’une vente (PAY-01…03).
 *
 * S'y ajoute, depuis SPEC-BOUTIQUE §5 :
 *   - `/admin/paiements/banque`               configuration bancaire (FAC-05).
 *
 * Et depuis SPEC-BOUTIQUE §8 bis B :
 *   - `/admin/paiements/relances`             modèle de relance (RLC-03).
 *
 * Le logiciel émet des QR-factures et permet de relancer un impayé — mais
 * JAMAIS de lui-même : c'est toujours l'opérateur qui choisit et déclenche
 * (RLC-02). Les fichiers bancaires s'importent désormais dans une file de
 * vérification, sans marquer automatiquement les factures comme payées.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'
import { RequireStaff } from '../../auth'

const ImpayesPage = lazy(() => import('./pages/ImpayesPage').then((m) => ({ default: m.ImpayesPage })))
const FichePaiementPage = lazy(() =>
  import('./pages/FichePaiementPage').then((m) => ({ default: m.FichePaiementPage })),
)
const ConfigurationBancairePage = lazy(() =>
  import('./pages/ConfigurationBancairePage').then((m) => ({
    default: m.ConfigurationBancairePage,
  })),
)
const ConfigurationRelancesPage = lazy(() =>
  import('./pages/ConfigurationRelancesPage').then((m) => ({
    default: m.ConfigurationRelancesPage,
  })),
)
const PageCaisse = lazy(() => import('./pages/PageCaisse').then((m) => ({ default: m.PageCaisse })))
const PageRapprochement = lazy(() => import('./pages/PageRapprochement').then((m) => ({ default: m.PageRapprochement })))
const PageComptabilite = lazy(() => import('./pages/PageComptabilite').then((m) => ({ default: m.PageComptabilite })))

export const routesPaiements: RouteObject[] = [
  { element: <RequireStaff roles={['admin', 'guichet']} />, children: [
  { index: true, element: <ImpayesPage /> },
  { path: 'souscription/:id', element: <FichePaiementPage type="souscription" /> },
  { path: 'vente/:id', element: <FichePaiementPage type="vente" /> },
  /* FAC-05 — le compte bancaire du théâtre. Il vit ici, avec l'argent, et non
     dans « Théâtre et salle » : ARCHITECTURE §9.2 interdit qu'une feature en
     importe une autre, et une IBAN n'a rien à voir avec un plan de salle. */
  { path: 'banque', element: <ConfigurationBancairePage /> },
  /* RLC-03 — le texte de relance, même raison de vivre ici : c'est de l'argent
     dû, pas un réglage éditorial générique. */
  { path: 'relances', element: <ConfigurationRelancesPage /> },
  { path: 'caisse', element: <PageCaisse /> },
  ] },
  { element: <RequireStaff roles={['admin', 'lecture']} />, children: [
    { path: 'rapprochement', element: <PageRapprochement /> },
    { path: 'comptabilite', element: <PageComptabilite /> },
  ] },
]
